import {Injectable, inject} from '@angular/core';
import {NgbDatepickerI18n, NgbDateStruct} from '@ng-bootstrap/ng-bootstrap';

interface I18nValues {
  weekdays: string[];
  months: string[];
  weekLabel: string;
}

interface I18nValuesMap {
  [key: string]: I18nValues;
}

export const I18N_VALUES: I18nValuesMap = {
  bg: {
    weekdays: ['Пон', 'Вто', 'Сря', 'Чет', 'Пет', 'Съб', 'Нед'],
    months: ['Яну', 'Фев', 'Мар', 'Апр', 'Май', 'Юни', 'Юли', 'Авг', 'Сеп', 'Окт', 'Ное', 'Дек'],
    weekLabel: 'Седмица',
  },
};

@Injectable()
export class I18n {
  language: keyof I18nValuesMap = 'bg';
}

@Injectable()
export class CustomDatepickerI18n extends NgbDatepickerI18n {
  private i18n = inject(I18n);

  public getWeekdayLabel(weekday: number): string {
    return I18N_VALUES[this.i18n.language].weekdays[weekday - 1];
  }

  public getMonthShortName(month: number): string {
    return I18N_VALUES[this.i18n.language].months[month - 1];
  }

  public getMonthFullName(month: number): string {
    return this.getMonthShortName(month);
  }

  public getDayAriaLabel(date: NgbDateStruct): string {
    return `${date.day}-${date.month}-${date.year}`;
  }

  public override getWeekLabel(): string {
    return I18N_VALUES[this.i18n.language].weekLabel;
  }
}
